import Reflux from 'reflux'
import FocusActions from '../actions/FocusActions'

export var HoldFousStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(FocusActions.holdFocusIn,'onHoldFocus');
	},
	onHoldFocus(formId,itemId)
	{
		this.trigger(formId,itemId);
	}

});

export var FocusChangeStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(FocusActions.focusChange,'onFocusChange');
	},
    onFocusChange(item,pre)
    {
		this.trigger(item,pre);
    }
});

export var FocusSetStore = Reflux.createStore(
{	
	init:function()
	{
		this.listenTo(FocusActions.focusSet,'onFocusSet');
	},
	onFocusSet(formId,itemId,pre,init,recordChange)
	{
		this.trigger(formId,itemId,pre,init,recordChange);
	}
});

export var CurrentGroupSetStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(FocusActions.currentGroupSet,'onGroupSet')
	},
	onGroupSet(groupAlias,formId,focusedId)
	{
		this.trigger(groupAlias,formId,focusedId);
	}
});

export var CurrentGroupGetStore = Reflux.createStore(

	{
		init:function()
		{
			this.listenTo(FocusActions.currentGroupGet,'onGroupGet');
		},
		onGroupGet(result)
		{
			this.trigger(result);
		}
	}
);

export var AfterNewRecordDataGridFocusSetStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(FocusActions.afterNewRecordDataGridFocusSet,'onAfterNewRecordDataGridFocusSet');
	},
	onAfterNewRecordDataGridFocusSet(formId,itemId)
	{
		this.trigger(formId,itemId);
	}
});

export var NotifyDataGridCurrentGroupStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(FocusActions.notifyDataGridCurrentGroup,'onNotifyDataGridCurrentGroup');
	},
	onNotifyDataGridCurrentGroup(groupAlias,formModule)
	{
		this.trigger(groupAlias,formModule);
	}
});

//废弃
export var SwitchToCurrentSetSelectStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(FocusActions.switchToCurrentSetSelect,"onSwitchToCurrentSetSelect");
	},
	onSwitchToCurrentSetSelect()
	{
		this.trigger();
	}

});

export var AfterActiveRecordStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(FocusActions.afterActiveRecord,'onAfterActiveRecord');
	},
	onAfterActiveRecord(groupAlias)
	{
		this.trigger(groupAlias);
	}
});

export var ScrollToAndFocusStore = Reflux.createStore({
	init:function()
	{
		this.listenTo(FocusActions.scrollToAndFocus,'onScrollToAndFocus');
	},
	onScrollToAndFocus(arg)
	{
		this.trigger(arg);
	}
});

export var ClearGridSignedStore = Reflux.createStore({
	init:function()
	{
		this.listenTo(FocusActions.clearSigned,'onClearSigned');
	},
	onClearSigned(arg)
	{
		this.trigger(arg);
	}
});

export var GlobalClickStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(FocusActions.globalClick,'onGlobalClick');
	},
	onGlobalClick(arg)
	{
		this.trigger(arg);
	}

});


// WEBPACK FOOTER //
// ./src/stores/FocusStore.js